import { createFileRoute } from '@tanstack/react-router';
import { PageShell } from '~/components/layout';
import {
  CtaBanner,
  DownloadQr,
  FaqAccordion,
  FeatureBlock,
  Hero,
  QuoteTestimonials,
  TextSection,
} from '~/components/sections';
import {
  businessHero,
  businessInvoices,
  businessPayTeam,
  businessReceive,
} from '~/content/business';
import { safeSpaceSection, trustedBySection } from '~/content/shared';
import { getTestimonials } from '~/lib/payload';
import { pageHeadMeta } from '~/lib/seo';
import heroCss from '~/styles/hero.css?inline';

export const Route = createFileRoute('/business')({
  loader: () => getTestimonials({ data: 'business' }),
  head: () =>
    pageHeadMeta({
      title: 'International USD, EUR, GBP Business Accounts',
      description:
        'For businesses, agencies, and registered entities (LLC, Ltd, etc.). Multi-currency accounts to receive from international clients (USD, EUR, GBP). Easy payroll for you and your team.',
      path: '/business',
      inlineStyles: [heroCss],
    }),
  component: BusinessPage,
});

function BusinessPage() {
  const quotes = Route.useLoaderData();

  return (
    <PageShell>
      <Hero content={businessHero} />
      <TextSection content={trustedBySection} />
      <FeatureBlock content={businessReceive} imagePosition="left" />
      <FeatureBlock content={businessPayTeam} imagePosition="right" ctaSlot={<DownloadQr />} />
      <FeatureBlock content={businessInvoices} imagePosition="left" />
      <TextSection content={safeSpaceSection} sectionClassName="max-md:!my-[40px]" />
      <QuoteTestimonials title="Trusted by businesses around the world" quotes={quotes} />
      <FaqAccordion />
      <CtaBanner />
    </PageShell>
  );
}
